/**
 * Probe Traefik/Authelia protection on /admin.
 * Returns true only when:
 *  1) GET /admin succeeds (HTTP 200) — path is allowed through Authelia
 *  2) GET /api/v1/admin/me succeeds — Remote-User is present and authorized
 *
 * (2) matters on LAN where Authelia may bypass auth but still leave no Remote-User,
 * so the public site stays admin-free for anonymous visitors.
 */
export async function canAccessAdmin(): Promise<boolean> {
  try {
    const res = await fetch("/admin", {
      method: "GET",
      credentials: "include",
      redirect: "manual",
      cache: "no-store",
      headers: { Accept: "text/html" },
    });
    // opaqueredirect = browser blocked reading a cross-origin redirect
    if (res.type === "opaqueredirect") return false;
    if (res.status >= 300 && res.status < 400) return false;
    if (res.status !== 200) return false;

    // Confirm real Authelia identity (not just network-level bypass of /admin)
    const me = await fetch("/api/v1/admin/me", {
      method: "GET",
      credentials: "include",
      redirect: "manual",
      cache: "no-store",
      headers: { Accept: "application/json" },
    });
    if (me.type === "opaqueredirect") return false;
    if (me.status >= 300 && me.status < 400) return false;
    return me.status === 200;
  } catch {
    return false;
  }
}
